<p-dialog
  [(visible)]="modalVisible"
  [modal]="true"
  [maximizable]="true"
  [closable]="false"
  [style]="{ width: '95vw', maxHeight: '95vh', maxWidth: '1400px' }"
  [breakpoints]="{ '1024px': '90vw', '768px': '95vw' }"
  [draggable]="false"
  [resizable]="false"
  styleClass="documentation-dialog"
  appendTo="body"
  (onMaximize)="handleDialogMaximize($event)"
  (onHide)="onDialogHide()">

  <ng-template pTemplate="header">
    <div class="dialog-header">
      <span class="dialog-title">
        {{ entity.id ? 'Editar Documentação' : 'Nova Documentação' }}
      </span>
      <span class="dialog-header-separator" aria-hidden="true"></span>
      <div class="dialog-header-toolbar">
        @if (entity.id) {
          <a
            pButton
            [href]="'https://docs.teorema.inf.br/doc/' + entity.id"
            target="_blank"
            rel="noopener noreferrer"
            icon="pi pi-external-link"
            pTooltip="Abrir no Docs"
            tooltipPosition="left"
            class="p-button-rounded p-button-text doc-header-action"
            aria-label="Abrir no Docs"></a>
        }
        <button
          type="button"
          pButton
          [icon]="dialogMaximized() ? 'bi bi-fullscreen-exit' : 'bi bi-arrows-fullscreen'"
          [pTooltip]="dialogMaximized() ? 'Sair da tela cheia' : 'Tela cheia'"
          tooltipPosition="left"
          class="p-button-rounded p-button-text doc-header-action"
          [attr.aria-label]="dialogMaximized() ? 'Sair da tela cheia' : 'Tela cheia'"
          [attr.title]="dialogMaximized() ? 'Sair da tela cheia' : 'Tela cheia'"
          (click)="toggleDialogMaximize()"></button>
        <button
          type="button"
          pButton
          icon="pi pi-times"
          class="p-button-rounded p-button-text doc-header-action"
          aria-label="Fechar"
          title="Fechar"
          (click)="cancelForm()"></button>
      </div>
    </div>
  </ng-template>

  @if (loading()) {
    <div class="form-loading">
      <p-skeleton height="2rem" styleClass="mb-3" />
      <p-skeleton height="2rem" styleClass="mb-3" />
      <p-skeleton height="5rem" />
    </div>
  } @else {
    <form [formGroup]="formGroup" class="form-content" autocomplete="off">

      <!-- Coluna 1 -->
      <div class="form-col">

        <div class="field">
          <label for="title">Título *</label>
          <input
            pInputText
            id="title"
            formControlName="title"
            placeholder="Digite o título da documentação"
            class="w-full" />
          @if (formGroup.get('title')?.invalid && formGroup.get('title')?.touched) {
            <small class="p-error">Título é obrigatório</small>
          }
        </div>

        <div class="field">
          <label for="slug">Slug</label>
          <div class="slug-field">
            <input
              pInputText
              id="slug"
              formControlName="slug"
              placeholder="slug-gerado-automaticamente"
              class="flex-1" />
            <p-button
              type="button"
              icon="pi pi-refresh"
              [text]="true"
              severity="secondary"
              size="small"
              (click)="generateSlug()"
              pTooltip="Gerar slug a partir do título"
              tooltipPosition="top" />
          </div>
          <small class="hint">Gerado automaticamente a partir do título.</small>
        </div>

        <div class="field">
          <label for="description">Descrição</label>
          <textarea
            pInputTextarea
            id="description"
            formControlName="description"
            placeholder="Breve descrição da documentação..."
            rows="3"
            class="w-full"></textarea>
        </div>

        <div class="field-row cols-3">
          <div class="field">
            <label for="category">Categoria *</label>
            <p-select
              inputId="category"
              formControlName="category"
              [options]="categoryOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Categoria"
              styleClass="w-full" />
          </div>
          <div class="field">
            <label for="version">Versão *</label>
            <input
              pInputText
              id="version"
              formControlName="version"
              placeholder="1.0.0"
              class="w-full" />
          </div>
          <div class="field">
            <label for="visibility">Visibilidade *</label>
            <p-select
              inputId="visibility"
              formControlName="visibility"
              [options]="visibilityOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Visibilidade"
              styleClass="w-full" />
          </div>
        </div>

        <div class="field">
          <patron-select
            label="Tickets Relacionados"
            placeholder="Selecione tickets"
            bindLabel="ticket_number_teorema"
            orderBy="ticket_number_teorema"
            modelName="tickets"
            [multiple]="true"
            [dropdownToFront]="true"
            [(ngModel)]="entity.tickets"
            [ngModelOptions]="{ standalone: true }" />
        </div>

        <div class="field">
          <patron-select
            label="Sistemas Relacionados"
            placeholder="Selecione sistemas"
            bindLabel="description"
            orderBy="description"
            modelName="systems"
            [multiple]="true"
            [dropdownToFront]="true"
            [(ngModel)]="entity.systems"
            [ngModelOptions]="{ standalone: true }" />
        </div>

      </div>

      <!-- Coluna 2 -->
      <div class="form-col">

        <div class="field">
          <div class="content-header">
            <label for="content">Conteúdo (Markdown)</label>
            <p-button
              type="button"
              label="Avançado"
              icon="pi pi-window-maximize"
              [outlined]="true"
              severity="secondary"
              size="small"
              [loading]="editorLoading()"
              (click)="openEditor()" />
          </div>
          <textarea
            pInputTextarea
            id="content"
            formControlName="content"
            placeholder="# Título&#10;&#10;## Seção&#10;&#10;Conteúdo em **Markdown**..."
            rows="5"
            class="w-full textarea-content"></textarea>
        </div>

        <div class="field">
          <label>Paths Hierárquicos</label>
          <app-path-selector
            [selectedPaths]="selectedPaths()"
            [primaryPathId]="primaryPathId()"
            (pathsChange)="onPathsChange($event)"
            (primaryChange)="onPrimaryChange($event)" />
          <small class="hint">Selecione onde a documentação pertencerá na árvore de diretórios.</small>
        </div>

        <div class="field-row cols-ai">
          <div class="checkbox-field">
            <p-checkbox formControlName="ai_context" inputId="ai_context" [binary]="true" />
            <label for="ai_context">Incluir no contexto de IA</label>
            <i
              class="pi pi-info-circle ai-info-icon"
              pTooltip="Ao marcar esta opção, o conteúdo desta documentação será indexado e utilizado como base de conhecimento para o assistente de IA."
              tooltipPosition="top"
              [tooltipOptions]="{ tooltipStyleClass: 'ai-tooltip' }"></i>
          </div>

          @if (formGroup.get('ai_context')?.value) {
            <div class="field ai-priority-field">
              <label for="ai_priority">Prioridade (1–10)</label>
              <input
                pInputText
                id="ai_priority"
                type="number"
                formControlName="ai_priority"
                min="1"
                max="10"
                class="w-full" />
            </div>
          }
        </div>

      </div>

    </form>
  }

  <ng-template pTemplate="footer">
    <p-button
      label="Cancelar"
      [text]="true"
      severity="secondary"
      [disabled]="loading()"
      (onClick)="cancelForm()" />
    <p-button
      label="Salvar"
      icon="pi pi-check"
      [loading]="loading()"
      (onClick)="save()" />
  </ng-template>
</p-dialog>

<!-- Editor avançado fullscreen -->
@if (editorOpen && editorUrl) {
  <div class="doc-editor-overlay">
    <div class="doc-editor-overlay__bar">
      <span class="doc-editor-overlay__title">
        <i class="pi pi-pencil mr-2"></i>
        {{ entity.title || 'Nova Documentação' }}
      </span>
      <button type="button" class="doc-editor-overlay__close" (click)="closeEditor()">
        <i class="pi pi-times"></i>
        Fechar
      </button>
    </div>
    <iframe
      [src]="safeEditorUrl"
      class="doc-editor-overlay__iframe"
      allow="clipboard-read; clipboard-write">
    </iframe>
  </div>
}
